import Vue from "vue";
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

export enum LangType {
    EN_US = "en_US",
    ZH_CN = "zh_CN",
    ZH_HK = "zh_HK"
}

export const DEFAULT_LANG = LangType.ZH_CN;
const LOCALE_KEY = "localeLanguage";

const locales = {
    "en_US": require("@/locale/lang/en_US"), //英文语言包
    "zh_CN": require('@/locale/lang/zh_CN'), //中文简体语言包
    "zh_HK": require('@/locale/lang/zh_HK'), //中文繁体语言包
}

const i18n = new VueI18n({
    locale: DEFAULT_LANG, // 语言标识
    messages: locales
})

/**
 * 设置语言
 * @param lang 
 */
export const setup = (lang?: string | null) => {
    if (!lang) {
        lang = localStorage.getItem(LOCALE_KEY);
        if (!lang || !(lang in locales)) {
            lang = DEFAULT_LANG;
        }
    }

    localStorage.setItem(LOCALE_KEY, lang);
    Object.keys(locales).forEach(lang => {
        document.body.classList.remove(`lang-${lang}`);
    });
    document.body.classList.add(`lang-${lang}`);
    document.body.setAttribute("lang", lang);

    i18n.locale = lang;
}

/**
 * 获取当前语言
 */
export const getLang = (): string => {
    let lang = localStorage.getItem(LOCALE_KEY);
    if (!lang) {
        lang = DEFAULT_LANG;
    }

    return lang;
}

export interface MessageDescriptor {
    id: string;
    description?: string;
    defaultMessage?: string;
}

export declare type MessageValue = string | number | boolean | Date | null | undefined;

export const formatMessage = (messageDescriptor: MessageDescriptor, values?: { [key: string]: MessageValue }): string => {
    const formMsg:any = i18n.t(messageDescriptor.id, values);

    if (!formMsg && messageDescriptor.defaultMessage) {
        return messageDescriptor.defaultMessage;
    }
    
    return formMsg ? formMsg.toString() : "";
}

setup()
window.i18n = i18n; //也可以通过window.i18n.t("message.common.name")使用

export default i18n;